import { Building2, Plus } from "lucide-react";

import Sidebar from "../../../common/sidebar/Sidebar";
import SidebarItem from "../../../common/sidebar/SidebarItem";

import { CompanyInfo } from "../../../../bitmaker/schemas/Billing/CompanyInfo";

interface CompanyInformationSidebarProps {
  companies: CompanyInfo[];
  selectedCompanyId: number | null;
  onSelectCompany: (id: number) => void;
  onAddCompany: () => void;
}

export default function CompanyInformationSidebar({
  companies,
  selectedCompanyId,
  onSelectCompany,
  onAddCompany,
}: CompanyInformationSidebarProps) {
  return (
    <Sidebar
      header={
        <>
          <h3 className="text-lg font-semibold text-gray-900">
            Companies ({companies.length})
          </h3>
          <p className="text-sm text-gray-500 mt-1">
            Manage your companies and billing entities
          </p>
        </>
      }
      action={
        <button onClick={onAddCompany} className="btn-dashed">
          <Plus size={18} />
          <span>Add Company</span>
        </button>
      }
    >
      {/* Company List */}
      {companies.map((company) => {
        const isActive = selectedCompanyId === company.id;

        return (
          <SidebarItem
            key={company.id}
            icon={<Building2 size={18} />}
            label={company.companyName}
            description={
              [company.townCity, company.country].filter(Boolean).join(", ") ||
              "No location"
            }
            isActive={isActive}
            onClick={() => onSelectCompany(company.id)}
          />
        );
      })}
    </Sidebar>
  );
}
